import moment from 'moment'

function formatTime(time) {
    let formattedTime = {
        'HH' : ('0' + moment(time, 'HH:mm:ss').hour()).slice(-2),
        'mm' : ('0' + moment(time, 'HH:mm:ss').minute()).slice(-2),
        'ss' : '00'
    }

    return formattedTime;
}

function timeToString(time) {

    let timeString = time.hour() + ':' + time.minutes() + ':00';
    //console.log(time.format('HH:mm:00'))
    return timeString;
}

function compareTime(time1, time2) {
   
}

export default {
    timeToString,
    formatTime
}
